import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Designers } from 'apps/find-designers/propTypes';
import { getComponentClasses } from '@99designs/common/utils/app';
import FeaturedSearch from './FeaturedSearch';

function StoreFront({ featuredSearches, isLoading, onClick }) {
    const classes = getComponentClasses('designer-list', [
        classNames({ 'loading-overlay': isLoading }),
    ]);
    return (
        <div className={classes}>
            {featuredSearches.map(search => (
                <div className="store-front__item" key={search.title}>
                    <FeaturedSearch search={search} onClick={onClick} />
                </div>
            ))}
        </div>
    );
}

StoreFront.propTypes = {
    featuredSearches: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            searchUrl: PropTypes.string.isRequired,
            designers: Designers.isRequired,
        })
    ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default StoreFront;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/StoreFront.jsx